import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const EcoTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={`${containerClass} bg-[#fcfdfa] text-stone-800`}>
      {!hideHeader && (
        <>
          {/* Organic Header Shape */}
          <div className="bg-[#e7eede] h-64 relative rounded-br-[100px] p-12 overflow-hidden">
             <div className="absolute top-0 right-0 w-64 h-64 bg-[#d5e0c4] rounded-full translate-x-1/3 -translate-y-1/3 opacity-50"></div>
             <div className="relative z-10 flex justify-between">
                <div className="flex gap-6 items-center">
                    <LogoImage size="md" />
                    <div>
                       <h1 className="text-3xl font-serif text-[#3f4f3a]">{profile.name}</h1>
                       <p className="text-sm text-[#5c6b57] mt-1">{profile.email}</p>
                    </div>
                </div>
                <div className="text-right">
                    <h2 className="text-4xl font-serif text-[#3f4f3a] opacity-20 uppercase">{type}</h2>
                    <div className="mt-4 space-y-1">
                       {metaData.map((m, i) => (
                           <p key={i} className="text-sm text-[#5c6b57]">
                               <span className="font-bold mr-2">{m.label}:</span> {m.value}
                           </p>
                       ))}
                    </div>
                </div>
             </div>
          </div>

          <div className="px-12 py-8 flex-1 flex flex-col">
              <div className="mb-12 pl-6 border-l-4 border-[#8fa87a]">
                 {client ? (
                     <>
                         <p className="text-xs font-bold text-[#8fa87a] uppercase tracking-wider mb-1">Prepared For</p>
                         <p className="font-serif text-2xl text-[#3f4f3a]">{client.name}</p>
                         <p className="text-[#5c6b57]">{client.company}</p>
                         <p className="text-sm text-[#8fa87a] mt-1">{client.address}</p>
                     </>
                 ) : <p className="text-stone-300">No Client</p>}
              </div>
          </div>
        </>
      )}

      <div className="px-12 py-8 flex-1 flex flex-col">
          <div className="flex-1 eco-table">
              {children}
          </div>

          <div className="mt-auto text-center py-8">
             <div className="inline-block px-8 py-2 border-t border-b border-[#e7eede] text-[#5c6b57] italic text-sm font-serif">
                {footerNote}
             </div>
          </div>
      </div>
    </div>
  );
};

export default EcoTemplate;